import { render, staticRenderFns } from "./sjtj.vue?vue&type=template&id=253a6ea6&"
import script from "./sjtj.vue?vue&type=script&lang=js&"
export * from "./sjtj.vue?vue&type=script&lang=js&"
import style0 from "./sjtj.vue?vue&type=style&index=0&id=253a6ea6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports